import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledFrame = styled.div`
  min-width: 288px;
  max-width: 400px;
  min-height: 200px;
  width: 100%;
  padding: 1px;
  background: var(--bundle-border-color);
  position: relative;
  border-radius: 7px;

  .price-container {
    width: 100%;
    position: absolute;
    bottom: 0;
    border-radius: 0 0 7px 7px;
    border: 1px solid #074e0e;

    .price {
      position: relative;
      height: auto;
      width: auto;
      padding: 3px 4px 4px 4px;
      border-radius: 0 0 7px 7px;
      &:before {
        content: '';
        width: 6px;
        height: 4px;
        background-color: white;
        border-radius: 50%;
        transform: rotate(-60deg);
        position: absolute;
        top: 5px;
        left: 7px;
      }
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        height: 16px;
        width: 100%;
        border-radius: 0 0 6px 6px;
        background: linear-gradient(270deg, #008668 0%, #6b9a11 100%);
      }
      .totalPrice {
        z-index: 1;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-shadow: -1px -1px 0 #034713, 1px -1px 0 #034713, -1px 1px 0 #034713,
          1px 1px 0 #034713, 0 2px 1px #034713;
        align-items: center;

        .availability {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 0.75rem;
          text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
            1px 1px 0 #000, 0 2px 1px #000;
          top: -40px;
          right: 8px;
        }
      }
    }
  }
` as any;

export const StyledSpecialOffer = styled.div`
  height: 200px;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.4);
  border-radius: 7px;

  .frame {
    height: 200px;
    width: 100%;
    background: ${(props: any) =>
      props.backgroundImage
        ? `url("${props.backgroundImage}")`
        : createGradientOrSolid(props.backgroundColor)};
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 7px;

    .products__container {
      width: 100%;
      margin: auto;
    }
  }
` as any;

export const ProductsBackground = styled.div`
  flex-wrap: wrap;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
` as any;
